import React from 'react';
import ContextToProps, { Contexts } from '@src/context/ContextToProps';
import Sort from './Sort';

const SortPropsProvider = () => {
  return (
    <ContextToProps enabled={[Contexts.SHOPPING, Contexts.SHOPPING_API]}>
      {({ shopping: { sort }, api: { shopping } }) => <Sort sort={sort} setSortType={shopping.sort.setSortType} />}
    </ContextToProps>
  );
};

export default SortPropsProvider;
